import { z } from 'zod'
import { oc } from '@orpc/contract'

export const healthcheckAdmin = oc.route({ method: 'GET', path: '/v2/healthcheck-admin' }).output(
  z.object({
    status: z.literal('ok'),
    user: z.object({
      profile: z.object({ reference: z.string() }),
    }),
    patients: z.object({ total: z.number() }),
  }),
)
